/**
 * Read timing
 */

const readTiming = () => {
  if (document.querySelector('.single-post') !== null) {
    const headerSel = document.querySelector('#ri-menu');
    const progressLine = `<div class="progress-reading"></div>`;

    let winHeight = window.innerHeight;
    let docHeight = document.body.clientHeight;
    let winToHeight = 0;
    let headerHeight = headerSel.offsetHeight;
    let contentHeight = document.querySelector('#main article').offsetHeight;
    let bodyWrap = headerHeight + contentHeight;

    headerSel.insertAdjacentHTML('beforebegin', progressLine);

    window.addEventListener('resize', function () {
      headerHeight = headerSel.offsetHeight;
      winHeight = window.innerHeight;
      docHeight = document.body.clientHeight;
    });

    window.addEventListener('scroll', function () {
      winToHeight = Math.ceil((window.scrollY / (docHeight - winHeight)) * 102);
      if (document.querySelector('.progress-reading') !== null) {
        document.querySelector('.progress-reading').style.width = winToHeight + '%';
      }
    });
  }
};

export { readTiming };
